import * as THREE from "three";
import React, { useRef, useEffect, memo } from "react";
import { useFrame, useThree } from "@react-three/fiber";
import { Text } from '@react-three/drei';
import Control from '../store/control';
import { TubeCurve } from '../shape/Spline';
import { Points } from "../shape/Point";


const MStandard = memo(({
  standardGeometry,
  color,
  colorHigh,
  colorSub
}) => {
  const material = new THREE.MeshLambertMaterial({color: color, transparent: true, opacity: 0.6, side: THREE.DoubleSide});
  const objects = [];
  objects.length = 0;

  let key = 0;

  if (typeof standardGeometry === 'undefined') {
    return null;
  }

  const afoMesh = new THREE.Mesh(standardGeometry, material);
  // show afoMesh
  objects.push(
    <primitive key={key} object={afoMesh} />
  );
  key += 1;

  // objects.push(<Points
  //   key={key}
  //   vpoints={vertices}
  //   color={color}
  //   size={1}
  // />)
  // key += 1;

  return objects.length !== 0 ? (
    <>
      {objects}
    </>
  ) : null;
});

export default MStandard;
